import React from 'react';
import { Icon, IconProps } from '~web/view/components/ui/icon.component';

export const CancelIcon: React.FunctionComponent<IconProps> = ({
  width = 24,
  height = 24,
  ...rest
}) => (
  <Icon width={width} height={height} viewBoxWidth={24} viewBoxHeight={24} {...rest}>
    <path d="M0 0h24v24H0z" fill="none" />
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z" />
  </Icon>
);



// WEBPACK FOOTER //
// /codebuild/output/src426716145/src/modules/web/src/js/view/components/ui/icon/cancel.icon.tsx